export enum NarrativeQuestionnaireItem {
  NARRATIVE_BACKGROUND = 'narrative/background',
  NARRATIVE_SYSTEM_SUMMARIES = 'narrative/system-summaries',
  NARRATIVE_CLINICAL_OVERVIEW = 'narrative/clinical-overview',
  NARRATIVE_SKILLED_NEEDS = 'narrative/skilled-needs',
  NARRATIVE_ADL_NEEDS = 'narrative/adl-needs',
  NARRATIVE_PATIENT_SERVICES = 'narrative/patient-services',
  NARRATIVE_CARE_COORDINATION = 'narrative/care-coordination',
  NARRATIVE_PATIENT_GOALS = 'narrative/patient-goals',
  NARRATIVE_CLINICAL_EDUCATION = 'narrative/clinical-education',
  NARRATIVE_FINAL_NOTES = 'narrative/final-notes'
}
